import type { GeneratingTextAreaProps } from 'ui/generating-text-area/generating-text-area.types';
import { useGeneratingTextArea } from 'ui/generating-text-area/use-generating-text-area';
import { TextArea } from 'ui/text-area';

const GeneratingTextArea = (props: GeneratingTextAreaProps) => {
  const { loading = false, value, onChange } = props;
  const { placeholder } = useGeneratingTextArea(loading);

  const handleChange = (nextValue: string) => {
    if (!loading) {
      onChange?.(nextValue);
    }
  };

  return (
    <TextArea
      {...props}
      value={loading ? '' : value ?? ''}
      onChange={handleChange}
      placeholder={placeholder}
    />
  );
};

export default GeneratingTextArea;
